
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#A4A8C0","d":"M19.531 6.813c.26 0 .469-.21.469-.47V4.47c0-.26-.21-.469-.469-.469h-1.875a.468.468 0 00-.468.469v.468H6.813V4.47a.465.465 0 00-.47-.469H4.47a.463.463 0 00-.47.468v1.875c0 .262.206.468.469.468h.468v10.375H4.47c-.26 0-.469.21-.469.47v1.874c0 .26.21.469.469.469h1.875c.259 0 .468-.21.468-.469v-.468h10.375v.468c0 .263.207.469.47.469h1.874a.464.464 0 00.469-.469v-1.875a.464.464 0 00-.469-.468h-.468V6.813h.468zm-1.406 10.375h-.469a.464.464 0 00-.468.468v.469H6.813v-.469a.468.468 0 00-.47-.468h-.468V6.813h.469a.465.465 0 00.468-.47v-.468h10.375v.469c0 .259.21.468.47.468h.468v10.375z"}}),_c('path',{attrs:{"fill":"#A4A8C0","d":"M15.281 7.281H8.72c-.26 0-.469.21-.469.469v1.875a.468.468 0 00.8.331l.8-.8h1.213v5.515l-.86 1.319a.468.468 0 00.391.729h2.812a.47.47 0 00.39-.729l-.858-1.32V9.157h1.212l.8.8a.467.467 0 00.8-.331V7.75c0-.26-.21-.469-.469-.469z"}})])
          )
        }
      }
    